import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useMemo, useState } from 'react';
import useSWR from 'swr';
export var useSWRFetch = function useSWRFetch(_ref) {
  var fallback = _ref.fallback,
    fetcher = _ref.fetcher,
    key = _ref.key;
  var formattedKey = JSON.stringify({
    key: key
  });
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentKey = _useState2[0],
    setCurrentKey = _useState2[1];
  var matchingKey = currentKey === formattedKey;
  var _useSWR = useSWR(currentKey, fetcher),
    data = _useSWR.data,
    error = _useSWR.error;
  var fetch = useCallback(function () {
    if (!matchingKey) {
      setCurrentKey(formattedKey);
    }
  }, [formattedKey, matchingKey]);
  return useMemo(function () {
    return {
      data: data !== null && data !== void 0 ? data : fallback,
      error: error,
      fetch: fetch,
      isLoaded: matchingKey && data != null && error == null,
      isLoading: data == null && error == null
    };
  }, [data, error, fallback, fetch, matchingKey]);
};